import React, { useState } from "react";
import { useCase } from "../../../provider/CaseProvider";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import { getProductData } from "../../../services/Product/ProductService/productService";
import { Box, Grid, Typography } from "@mui/material";
import { EditNote, UnfoldLess, UnfoldMore } from "@mui/icons-material";
import { userHasRole } from "../../../services/backofficeUserService";
import { Roles } from "../../../types/BackofficeUser";
import IconButton from "@mui/material/IconButton";
import { useCurrentEditor } from "@tiptap/react";
import ContentBox from "../../ContentBox/ContentBox";
import { useDrawer } from "../../../provider/DrawerProvider";

export default function CaseDescription() {
  const { product } = useCase();
  const { editor } = useCurrentEditor();
  const currentUser = useCurrentUser();
  const [expanded, setExpanded] = useState(false);
  const { setDrawerState } = useDrawer();

  if (
    !product ||
    !product.caseDescription ||
    !getProductData(product.productClassName, "showCaseDescription")({ product })
  ) {
    return null;
  }

  return (
    <ContentBox>
      <Grid container spacing={1} sx={{
        alignItems: "center"
      }}>
        <Grid
          sx={{
            flexGrow: 1
          }}>
          <Typography variant="h3">Fallzusammenfassung</Typography>
        </Grid>
        <Grid>
          {!editor?.isEmpty && (
            <IconButton onClick={() => setExpanded((prevState) => !prevState)}>
              {expanded ? <UnfoldLess /> : <UnfoldMore />}
            </IconButton>
          )}
        </Grid>
        <Grid>
          {product.caseCategory !== "advisory" && !userHasRole(currentUser, Roles.external) && (
            <IconButton onClick={() => setDrawerState({ type: "caseDescription" })}>
              <EditNote />
            </IconButton>
          )}
        </Grid>
      </Grid>
      {
        <Box
          sx={expanded ? {} : { maxHeight: "6rem", overflow: "hidden" }}
          dangerouslySetInnerHTML={{ __html: product.caseDescription }}
        />
      }
    </ContentBox>
  );
}
